import { useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';
import { watchAiJobs } from './assistantBus';

const EXPECTED = 45;

// Studio-wide progress for AI images: animated bar + time hint; the customer can keep designing meanwhile.
export const AiJobsBar = () => {
  const [jobs, setJobs] = useState([]), [, tick] = useState(0);
  useEffect(() => watchAiJobs(setJobs), []);
  useEffect(() => { if (!jobs.length) return; const t = setInterval(() => tick(x => x + 1), 1000); return () => clearInterval(t); }, [jobs.length]);
  if (!jobs.length) return null;
  const job = jobs[0], secs = Math.round((Date.now() - job.started) / 1000), share = Math.min(.95, 1 - Math.exp(-secs / EXPECTED));
  return <div className="ai-jobs-bar" role="status" aria-live="polite" data-testid="ai-jobs-bar">
    <Sparkles size={15} className="ai-jobs-icon" />
    <span><strong data-testid="ai-jobs-label">{job.label}{jobs.length > 1 ? ` (+${jobs.length - 1})` : ''} …</strong><small>{secs < 60 ? `${secs} s` : `${Math.floor(secs / 60)}:${String(secs % 60).padStart(2, '0')} min`} · du kannst währenddessen weiter gestalten</small></span>
    <i className="ai-jobs-track"><b style={{ width: `${Math.round(share * 100)}%` }} /></i>
  </div>;
};
